import { render, staticRenderFns } from "./changelog-follow-up.vue?vue&type=template&id=3d39c19a"
import script from "./changelog-follow-up.vue?vue&type=script&lang=js"
export * from "./changelog-follow-up.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports